import React from 'react'
import { Box, Modal } from '@mui/material'
import style from 'components/moreDetails/MoreDetailsStyle'


function CommonImageModal(props) {
    const handleClose = () => {
      props?.handleClose();
    }
  return (
    <div>
      <Modal
        open={props?.open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img src={props?.selectedImage} alt="driving" className='height500 width600' />
        </Box>
      </Modal>
    </div>
  )
}

export default CommonImageModal;